<span cdkOverlayOrigin #origin="cdkOverlayOrigin"></span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="closed.emit()"
  (detach)="closed.emit()">
  <div
    class="bg-white border-standard-divider rounded-md border p-3 shadow-xl w-full"
    style="width: 300px"
    data-testid="simple-overlay">
    <ng-container *ngTemplateOutlet="messageContent()" />
    <div class="flex gap-3 pt-2">
      <aw-button
        class="w-full"
        [id]="'cancel'"
        [type]="'button'"
        [buttonSize]="'small'"
        (click)="closed.emit()"
        [style]="'primary-alt'"
        [text]="cmsTextProvider.shared.cancel" />
      <aw-button
        [id]="'confirm'"
        [type]="'button'"
        [buttonSize]="'small'"
        (click)="accepted.emit()"
        [style]="'error-alt'"
        [text]="cmsTextProvider.shared.delete"
        class="mr-3 w-full" />
    </div>
  </div>
</ng-template>